"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_router_dom_1 = require("react-router-dom");
var urls_1 = __importDefault(require("../../app/urls"));
var components_1 = require("../../common/components");
var TaskNavigation_1 = __importDefault(require("./components/TaskNavigation"));
var store_1 = require("../../app/store");
var translate_1 = __importDefault(require("../../app/localization/translate"));
var OutsideTaskContent_1 = __importDefault(require("./components/OutsideTaskContent"));
var outsideService_1 = require("../../app/services/outsideService");
var Task = function () {
    var _a, _b;
    var translate = (0, translate_1.default)();
    var dispatch = (0, store_1.useYouwellDispatch)();
    var _c = (0, react_router_dom_1.useParams)(), programId = _c.programId, moduleIndex = _c.moduleIndex, taskIndex = _c.taskIndex;
    var program = (0, store_1.useYouwellSelector)(function (state) { return state.outsideStore.programDetails[programId]; });
    var loadingProgram = (0, store_1.useYouwellSelector)(function (state) { return state.requestStatusStore.loading; });
    var module = (_a = program === null || program === void 0 ? void 0 : program.modules) === null || _a === void 0 ? void 0 : _a[Number(moduleIndex)];
    var task = (_b = module === null || module === void 0 ? void 0 : module.tasks) === null || _b === void 0 ? void 0 : _b[Number(taskIndex) || 0];
    (0, react_1.useEffect)(function () {
        if (!program && programId) {
            (0, outsideService_1.fetchOutsideProgram)(dispatch, programId);
        }
    }, [dispatch, program, programId]);
    if (!task || !module) {
        return loadingProgram ? null : react_1.default.createElement(components_1.InfoMessage, { messageKey: "noTask" });
    }
    var sidemenu = {
        currentIndex: Number(taskIndex) || 0,
        title: task.moduleName,
        menuItems: module.tasks.map(function (t, i) { return ({
            text: t.name,
            url: "".concat(urls_1.default.outsideProgram.task, "/").concat(programId, "/").concat(moduleIndex, "/").concat(i),
        }); }),
    };
    return (react_1.default.createElement(components_1.PageLayout, { title: task.name, task: task, sideMenu: sidemenu, key: task.id },
        react_1.default.createElement(components_1.PageTitle, { title: "".concat(translate('header.title'), " - ").concat(task.moduleName) }),
        react_1.default.createElement(OutsideTaskContent_1.default, { task: task }),
        react_1.default.createElement(TaskNavigation_1.default, { task: __assign(__assign({}, task), { elementIndex: Number(moduleIndex), currentTaskNr: Number(taskIndex), listLength: module.tasks.length, programId: programId }) })));
};
exports.default = Task;
